"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var q_play_core_1 = require("@nordicscreen/q-play-core");
var AjaxProvider_1 = __importDefault(require("../../functions/AjaxProvider"));
var AppIntegrationHelper = /** @class */ (function () {
    function AppIntegrationHelper() {
        this.appIntegrationTemplates = [];
        this.appIntegration = [];
        this.appIntegrationServer = [];
        this.ajaxProvider = (0, AjaxProvider_1.default)("/api");
    }
    AppIntegrationHelper.prototype.getIntegrationTemplate = function (id) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var params, response_1, info_1, settingsMap_1;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!!this.appIntegrationTemplates[id]) return [3 /*break*/, 2];
                        params = { id: id };
                        return [4 /*yield*/, this.ajaxProvider.getOne("app-integration-templates", params)];
                    case 1:
                        response_1 = _b.sent();
                        info_1 = {
                            id: id,
                            name: response_1.data.name,
                            type: response_1.data.type,
                            current_version: response_1.data.current_version,
                            current_patch_version: response_1.data.current_patch_version,
                            icon: response_1.data.icon,
                            description: response_1.data.description,
                            description_link: response_1.data.description_link,
                            visible: response_1.data.visible,
                            created_at: response_1.data.created_at,
                            updated_at: response_1.data.updated_at,
                            created_by: response_1.data.created_by,
                            definition: {
                                setup_quick_guide: response_1.data.setup_quick_guide,
                                script: {
                                    version: response_1.data.script.version,
                                    settings: [],
                                    resources: {},
                                    translations: response_1.data.translations,
                                }
                            }
                        };
                        settingsMap_1 = this.getDefaultIntegrationSettings();
                        if ((_a = response_1.data.script) === null || _a === void 0 ? void 0 : _a.settings) {
                            Object.keys(response_1.data.script.settings).forEach(function (key) {
                                settingsMap_1[key] = q_play_core_1.Setting.createSettingFromData(key, response_1.data.script.settings[key], settingsMap_1[key]);
                            });
                        }
                        Object.keys(settingsMap_1).forEach(function (key) {
                            info_1.definition.script.settings.push(settingsMap_1[key]);
                        });
                        info_1.definition.script.settings.sort(function (a, b) { return a.order > b.order ? 1 : (a.order < b.order ? -1 : 0); });
                        Object.keys(response_1.data.script.resources).map(function (identifier) {
                            var defaultSettings;
                            if (info_1.type === "webcapture") {
                                defaultSettings = _this.getDefaultWebCaptureResourceSettings();
                            }
                            else { // webapi
                                defaultSettings = _this.getDefaultWebApiResourceSettings();
                            }
                            info_1.definition.script.resources[identifier] = _this.createResourceFromData(defaultSettings, response_1.data.script.resources[identifier]);
                        });
                        this.appIntegrationTemplates[id] = info_1;
                        _b.label = 2;
                    case 2: return [2 /*return*/, this.appIntegrationTemplates[id]];
                }
            });
        });
    };
    AppIntegrationHelper.prototype.getIntegration = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!this.appIntegration[id]) {
                    this.loadIntegration(id);
                }
                return [2 /*return*/, this.appIntegration[id]];
            });
        });
    };
    AppIntegrationHelper.prototype.loadIntegration = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var params, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = { id: id };
                        return [4 /*yield*/, this.ajaxProvider.getOne("app-integrations", params)];
                    case 1:
                        response = _a.sent();
                        this.addAppIntegrationFromResponse(response.data);
                        return [2 /*return*/, this.appIntegration[id]];
                }
            });
        });
    };
    AppIntegrationHelper.prototype.loadIntegrationServer = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var params, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = { id: id };
                        return [4 /*yield*/, this.ajaxProvider.getOne("app-integration-servers", params)];
                    case 1:
                        response = _a.sent();
                        this.addAppIntegrationServerFromResponse(response.data);
                        return [2 /*return*/, this.appIntegrationServer[id]];
                }
            });
        });
    };
    AppIntegrationHelper.prototype.getIntegrationJobs = function (integrationId, identifier) {
        return __awaiter(this, void 0, void 0, function () {
            var params, list, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = {
                            pagination: { page: 1, perPage: 5 },
                            sort: { field: "id", order: "ASC" },
                            filter: {}
                        };
                        list = [];
                        return [4 /*yield*/, (0, AjaxProvider_1.default)("/api").getList("app-integrations/" + integrationId + "/jobs/" + identifier, params)];
                    case 1:
                        response = _a.sent();
                        response.data.forEach(function (result) {
                            list.push({
                                id: result.id,
                                integration_id: integrationId,
                                resource: result.resource,
                                exit_code: result.exit_code,
                                exit_message: result.exit_message,
                                ended_at: result.ended_at ? new Date(result.ended_at) : undefined,
                                has_result: result.has_result,
                                has_failure_result: result.has_failure_result,
                                created_at: new Date(result.created_at),
                            });
                        });
                        return [2 /*return*/, list];
                }
            });
        });
    };
    AppIntegrationHelper.prototype.getIntegrationJob = function (integrationId, identifier, id) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var params, response;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        params = { id: id };
                        return [4 /*yield*/, this.ajaxProvider.getOne("app-integrations/" + integrationId + "/jobs/" + identifier, params)];
                    case 1:
                        response = _b.sent();
                        return [2 /*return*/, {
                                id: response.data.id,
                                integration_id: integrationId,
                                resource: response.data.resource,
                                logs: (_a = response.data.logs) === null || _a === void 0 ? void 0 : _a.map(function (text) {
                                    return text ? {
                                        timestamp: new Date("".concat(text.substring(1, 12), " ").concat(text.substring(13, 21), " ").concat(text.substring(22, 27))),
                                        line: text.substring(29)
                                    } : undefined;
                                }).filter(function (entry) { return entry !== undefined; }),
                                exit_code: response.data.exit_code,
                                exit_message: response.data.exit_message,
                                ended_at: response.data.ended_at ? new Date(response.data.ended_at) : undefined,
                                has_result: response.data.has_result,
                                has_failure_result: response.data.has_failure_result,
                                created_at: new Date(response.data.created_at),
                            }];
                }
            });
        });
    };
    AppIntegrationHelper.prototype.createAppIntegration = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var params, response, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = { data: data };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.ajaxProvider.create("app-integrations", params)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, this.addAppIntegrationFromResponse(response.data.data)];
                    case 3:
                        e_1 = _a.sent();
                        return [2 /*return*/, undefined];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    AppIntegrationHelper.prototype.updateAppIntegration = function (id, data) {
        return __awaiter(this, void 0, void 0, function () {
            var params, response, e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = { id: id, data: data, previousData: {} };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.ajaxProvider.update("app-integrations", params)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, this.addAppIntegrationFromResponse(response.data.data)];
                    case 3:
                        e_2 = _a.sent();
                        return [2 /*return*/, null];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    AppIntegrationHelper.prototype.addAppIntegrationFromResponse = function (data) {
        var _a;
        var id = data === null || data === void 0 ? void 0 : data.id;
        if (id) {
            this.appIntegration[id] = {
                id: id,
                template_id: data.template_id,
                version: data.version,
                name: data.name,
                server_id: data.server_id,
                definition: {
                    setup: data.setup,
                    resources: data.resources,
                }
            };
            if (Array.isArray(this.appIntegration[id].definition.setup)) {
                this.appIntegration[id].definition.setup = { variables: {} };
            }
            if (Array.isArray(this.appIntegration[id].definition.setup.variables)) {
                this.appIntegration[id].definition.setup.variables = {};
            }
            if (Array.isArray(this.appIntegration[id].definition.resources)) {
                this.appIntegration[id].definition.resources = {};
            }
        }
        return (_a = this.appIntegration[id]) !== null && _a !== void 0 ? _a : undefined;
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    AppIntegrationHelper.prototype.addAppIntegrationServerFromResponse = function (data) {
        var _a;
        var id = data === null || data === void 0 ? void 0 : data.id;
        if (id) {
            this.appIntegrationServer[id] = {
                id: id,
                identifier: data.identifier,
                name: data.name,
                management_access: data.management_access,
                resource_access: data.resource_access,
                player_host: data.player_host,
                player_psk: data.player_psk,
                private: data.private,
                expected_heartbeat_freq: data.expected_heartbeat_freq,
                last_heartbeat_at: data.last_heartbeat_at ? new Date(data.last_heartbeat_at) : undefined,
                first_heartbeat_at: data.first_heartbeat_at ? new Date(data.first_heartbeat_at) : undefined,
                created_at: data.created_at ? new Date(data.created_at) : undefined,
                updated_at: data.updated_at ? new Date(data.updated_at) : undefined,
                deleted_at: data.updated_at ? new Date(data.deleted_at) : undefined,
            };
        }
        return (_a = this.appIntegrationServer[id]) !== null && _a !== void 0 ? _a : undefined;
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    AppIntegrationHelper.prototype.createResourceFromData = function (defaultSettings, data) {
        var settings = [];
        if (data.settings) {
            Object.keys(data.settings).forEach(function (key) {
                var setting = q_play_core_1.Setting.createSettingFromData(key, data.settings[key], defaultSettings[key]);
                if (setting) {
                    defaultSettings[key] = setting;
                }
            });
        }
        Object.keys(defaultSettings).forEach(function (key) {
            settings.push(defaultSettings[key]);
        });
        settings.sort(function (a, b) { return a.order > b.order ? 1 : (a.order < b.order ? -1 : 0); });
        data.settings = settings;
        return data;
    };
    AppIntegrationHelper.prototype.getDefaultIntegrationSettings = function () {
        var settings = {};
        var baseUrl = new q_play_core_1.StringSetting("base_url", "URL");
        baseUrl.layout = "default";
        baseUrl.required = true;
        baseUrl.order = 10;
        settings["base_url"] = baseUrl;
        var refreshOndemand = new q_play_core_1.BooleanSetting("refresh_ondemand", "On-demand");
        refreshOndemand.required = true;
        refreshOndemand.defaultValue = true;
        refreshOndemand.section = "secondary";
        refreshOndemand.fixed = false;
        refreshOndemand.order = 20;
        refreshOndemand.visible = false;
        settings["refresh_ondemand"] = refreshOndemand;
        var refresh = new q_play_core_1.SelectSetting("refresh", "Refresh rate");
        refresh.layout = "default";
        refresh.section = "secondary";
        refresh.required = true;
        refresh.defaultValue = "120";
        refresh.order = 30;
        refresh.options = [
            { value: "0", label: "Never" },
            { value: "120", label: "Every 2nd minute" },
            { value: "300", label: "Every 5th minute" },
            { value: "600", label: "Every 10th minute" },
            { value: "900", label: "Every 15th minute" },
            { value: "1800", label: "Every 30th minute" },
            { value: "2700", label: "Every 45th minute" },
            { value: "3600", label: "Every hour" },
            { value: "7200", label: "Every 2nd hour" },
        ];
        settings["refresh"] = refresh;
        return settings;
    };
    AppIntegrationHelper.prototype.getDefaultWebCaptureResourceSettings = function () {
        var settings = {};
        var url = new q_play_core_1.StringSetting("url", "URL");
        url.required = true;
        url.order = 10;
        settings["url"] = url;
        var refresh = new q_play_core_1.SelectSetting("refresh", "Refresh rate");
        refresh.layout = "default";
        refresh.section = "secondary";
        refresh.required = true;
        refresh.description = "The min. time between webcapture image generation";
        refresh.order = 20;
        refresh.options = [
            { value: "", label: "Use global" },
            { value: "60", label: "Every minute" },
            { value: "120", label: "Every 2nd minute" },
            { value: "300", label: "Every 5th minute" },
            { value: "600", label: "Every 10th minute" },
            { value: "900", label: "Every 15th minute" },
            { value: "1800", label: "Every 30th minute" },
            { value: "2700", label: "Every 45th minute" },
            { value: "3600", label: "Every hour" },
            { value: "7200", label: "Every 2nd hour" },
        ];
        settings["refresh"] = refresh;
        var size = new q_play_core_1.SelectSetting("size", "Page size");
        size.layout = "default";
        size.section = "secondary";
        size.description = "The visible size of the webpage.";
        size.required = true;
        size.defaultValue = "1920x1080";
        size.order = 30;
        size.options = [
            { value: "custom", label: "Custom" },
            { value: "800x600", label: "800x600" },
            { value: "1024x768", label: "1024x768" },
            { value: "1280x1024", label: "1280x1024" },
            { value: "1920x1080", label: "1920x1080" },
        ];
        settings["size"] = size;
        var width = new q_play_core_1.IntegerSetting("width", "Page width");
        width.layout = "default";
        width.section = "secondary";
        width.description = "The visible width of the webpage.";
        width.required = true;
        width.defaultValue = 1920;
        width.conditions.push({
            setting: "size",
            value: "custom",
            type: "disable"
        });
        width.order = 40;
        settings["width"] = width;
        var height = new q_play_core_1.IntegerSetting("height", "Page height");
        height.layout = "default";
        height.section = "secondary";
        height.description = "The visible height of the webpage.";
        height.required = true;
        height.defaultValue = 1080;
        height.conditions.push({
            setting: "size",
            value: "custom",
            type: "disable"
        });
        height.order = 50;
        settings["height"] = height;
        return settings;
    };
    AppIntegrationHelper.prototype.getDefaultWebApiResourceSettings = function () {
        var settings = {};
        return settings;
    };
    return AppIntegrationHelper;
}());
var appIntegrationHelper = new AppIntegrationHelper();
exports.default = appIntegrationHelper;
